import React from "react";
import { Selection } from "../../../../../src/application/Contracts";
import TankTechnicalData = Selection.TankTechnicalDataModel;
import TankFamily = Selection.TankFamily;
import { EnumsTextHelper } from "../EnumsTextHelper";

export class TankSelectionTechnicalData extends React.Component<TankTechnicalData>
{
    renderRow = (label: string, value: any, unit?: string, isMainProperty?: boolean) => {
        if (!value) {
            return <></>
        }
        const className = isMainProperty ? `main-property` : ``;
        return <tr className={className}>
            <td>{__(label)}</td>
            <td>{value} {unit}</td>
        </tr>
    }

    renderEmpty = () => {
        return <div className={`empty-expandable-container-results`}>{__('No matching technical data')}</div>
    }

    render() {
        if (this.props?.articleName == null) {
            return this.renderEmpty();
        }

        return <React.Fragment>
            <div className={`step-inputs-row grid-2`}>
                <div className={`card properties-card`}>
                    <div className={'card-header'}>
                        {__('Tank technical data')}
                    </div>
                    <div className={`card-body`}>
                        <table className={`step-stripped-table`}>
                            <tbody className={`left-text-align`}>
                                {this.renderRow('Insulation description', this.props.insulationDescription, "")}
                                {this.renderRow('Thermal loos', this.props.thermalLoos, this.getThermalLoosUnit())}
                                {this.renderRow('Max operating temp', this.props.maxOperatingTemp, "°C")}
                                {this.renderRow('Total height', this.props.totalHeight, "mm")}
                                {this.renderRow('Max operating pressure', this.props.maxOperatingPressure, "barg")}
                                {this.renderRow('Weight', this.props.weight * this.props.quantity, `kg for ${this.props.quantity} tank(s)`)}
                                {this.renderRow('Total diameter', this.props.totalDiameter, "mm")}
                                {this.renderRow('Inspection hole', this.props.inspectionHole, "")}
                                {this.renderRow('Charging conn diameter', this.props.chargingConnDiam, "")}
                                {this.renderRow('Recycling conn diameter', this.props.recyclingConnDiameter, "")}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={`card properties-card`}>
                    <div className={'card-header'}>
                        {__('Tank technical data')}
                    </div>
                    <div className={`card-body`}>
                        <table className={`step-stripped-table`}>
                            <tbody className={`left-text-align`}>
                                {this.renderRow('Product family', EnumsTextHelper.GetProductFamilyTextFromSlug(this.props.productFamilySlug as TankFamily), "")}
                                {this.renderRow('Product series', this.props.productSeries, "")}
                                {this.renderRow('Product article name', this.props.articleName, "", true)}
                                {this.renderRow('Quantity', this.props.quantity, "")}
                                {this.renderRow('Volume', this.props.volume, "L")}
                                {this.renderRow('Tank material', __(this.props.material), "")}
                                {this.renderRow('Tilting height', this.props.tiltHeight, "mm")}
                                {this.renderRow('Inspection diameter', this.props.inspectionDiameter, "mm")}
                                {this.renderRow('Cold/Hot water conn diameter', this.props.coldHotWaterConnectionDiameter, "")}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }

    getThermalLoosUnit(): string | undefined {
        let result = "kWh/24h";
        if (this.props.productSeries.indexOf("7bar") || this.props.productSeries.indexOf("5 bar")) {
            result = "UA (W/K)"
        }
        return result;
    }
}